import React, { ReactElement } from "react";

export default function HideIcon(): ReactElement {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="72"
            height="72"
            fill="none"
            viewBox="0 0 72 72"
        >
            <path
                fill="#FE895C"
                d="M13.964 24.6a69.64 69.64 0 00-12.52 10.587 1.666 1.666 0 000 2.264c3.826 4.142 18.074 18.193 35.06 18.193a33.21 33.21 0 007.597-.907l-6.114-6.114c-.492.057-.987.086-1.483.086a12.385 12.385 0 01-12.386-12.386c0-.495.03-.99.087-1.483L13.965 24.6zM71.557 37.451a1.666 1.666 0 000-2.264c-3.827-4.142-18.075-18.185-35.053-18.185a35.376 35.376 0 00-12.407 2.387L8.685 3.977l-4.53 4.53L64.318 68.67l4.53-4.53L55.11 50.402a68.194 68.194 0 0016.447-12.95zm-27.885 1.513a7.633 7.633 0 00-9.815-9.815l-3.537-3.538A12.356 12.356 0 0147.21 42.504l-3.539-3.539z"
            ></path>
        </svg>
    );
}
